class AgreeCheckbox {
    static attach() {
        const allCheckboxElements = [...document.querySelectorAll(`[data-toggle="agree"]`)];
        allCheckboxElements.forEach((agreeCheckboxElement) => {
            /* eslint-disable-next-line no-unused-vars */
            const agreeCheckbox = new AgreeCheckbox(agreeCheckboxElement, allCheckboxElements);
        });
    }

    constructor(checkbox, allCheckboxElements) {
        this.allCheckboxElements = allCheckboxElements;
        this.checkboxElement =
            typeof checkbox === "string" ? document.querySelector(checkbox) : checkbox;
        this.targetElement = document.querySelector(this.checkboxElement.dataset.target);
        this.checkAllAgreedStatus();

        if (this.checkboxElement) {
            this.checkboxElement.addEventListener("change", (event) => {
                this.handleCheckboxChange(event);
            });
        }

        if (this.targetElement) {
            if (this.targetElement.dataset.hasEvent !== "true") {
                this.targetElement.dataset.hasEvent = "true";
                this.targetElement.addEventListener("click", (event) => {
                    this.handleTargetClick(event);
                });
            }
        }

        this.updateView();
    }

    handleCheckboxChange() {
        this.checkAllAgreedStatus();
    }

    handleTargetClick(event) {
        this.checkAllAgreedStatus();
        if (!this.allAgreed) {
            event.preventDefault();
        }
    }

    checkAllAgreedStatus() {
        this.allAgreed = true;
        this.allCheckboxElements.forEach((checkboxElement) => {
            if (!checkboxElement.checked) {
                this.allAgreed = false;
            }
        });

        this.updateView();
    }

    updateView() {
        if (!this.allCheckboxElements || !this.targetElement) {
            return;
        }

        if (this.allAgreed) {
            this.targetElement.disabled = false;
            this.targetElement.classList.remove("is-disabled");
        } else {
            this.targetElement.disabled = true;
            this.targetElement.classList.add("is-disabled");
        }
    }
}

export { AgreeCheckbox };
